// extracted by mini-css-extract-plugin
module.exports = {"root":"OngoingMeeting_root__1KJZQ","title":"OngoingMeeting_title__3DdlK","text":"OngoingMeeting_text__2qad2","btnWrapper":"OngoingMeeting_btnWrapper__2xmEx"};